// This file was auto-generated by Fern from our API Definition.
export var EvaluationRunDataStepOutput;
(function (EvaluationRunDataStepOutput) {
    EvaluationRunDataStepOutput.Type = {
        Input: "input",
        Invocation: "invocation",
        Annotation: "annotation",
    };
    EvaluationRunDataStepOutput.Origin = {
        Custom: "custom",
        Human: "human",
        Auto: "auto",
    };
})(EvaluationRunDataStepOutput || (EvaluationRunDataStepOutput = {}));
